import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

export const Form = styled.form`
    #login-button {
        margin-top: ${token('space.300', '24px')};
    }
`;

export const ForgotPasswordLinkContainer = styled.div`
    margin-top: ${token('space.300', '24px')};
    text-align: center;
`;

export const ContactAdminLink = styled.div`
    display: inline;
`;
